import {Race} from "./race";

export interface CompetitorResults {
  rowId?: number;
  id?: number;
  raceId?: number;
  eventId?: number;
  firstName?: string;
  lastName?: string;
  sex?: number;
  status?: string;
  category?: number;
  categoryLabel?: string;
  startNumber?: string;
  country?: string;
  placeOfResidence?: string;
  club?: string;
  grouping?: string;
  absoluteRank?: number;
  sexRank?: number;
  categoryRank?: number;
  chipAbsoluteRank?: number;
  chipSexRank?: number;
  chipCategoryRank?: number;
  results?: number;
  created?: Date;
  totalTime?: number;
  startTime?: string;
  finishTime?: string;
  SGS?: string;
  race?: Race;
  competitorResultsDetail?: CompetitorResultsDetail;
}

export interface CompetitorResultsDetail {
  tl_tm?: string;
  st_tm?: string;
  SGS?: { [key: string]: CompetitorStageDetail };
  laps?: { [key: string]: CompetitorStageDetail };
  st_dc?: number;
  ch_tm?: string;
  ch_dc?: number;
  fn_tm?: string;
  fn_dc?: number;
  fn_cp?: number;
  fn_pen?: number;
  fn_tm_pen?: string;
  tl_tm_pen?: string;
  tl_ch_tm?: string;
  tl_ch_tm_pen?: string;
  LTP?: string;
  team?: TeamMember[];
  bike?: string;
  league?: string;
  tl_lp?: number;
}
export interface CompetitorStageDetail {
  cp_id?: string;
  pr?: string;
  nm?: string;
  lp?: number;
  tp?: number;
  tl_tm?: string;
  nt_tm?: string;
  lp_tm?: string;
  tl_ch?: string;
  nt_ch?: string;
  st_tm?: string;
  st_dc?: number;
  ch_tm?: string;
  ch_dc?: number;
  ps_tm?: string;
  ps_dc?: number;
  abrk?: number;
  sxrk?: number;
  ctrk?: number;
}

export function areCompetitorResultsEqual(result1: CompetitorResults, result2: CompetitorResults): boolean {
  const primitiveFields: (keyof CompetitorResults)[] = [
    'id', 'raceId', 'eventId', 'firstName', 'lastName', 'sex', 'status', 'category', 'categoryLabel',
    'startNumber', 'country', 'placeOfResidence', 'club', 'grouping', 'absoluteRank', 'sexRank', 'categoryRank',
    'chipAbsoluteRank', 'chipSexRank', 'chipCategoryRank', 'results', 'totalTime', 'startTime', 'finishTime', 'SGS'
  ];

  for (const field of primitiveFields) {
    if (!result1 && result2) return false;
    if (result1 && !result2) return false;
    if (result1[field] !== result2[field]) return false;
  }

  if (!compareCompetitorResultsDetail(result1.competitorResultsDetail, result2.competitorResultsDetail)) return false;
  return true;
}


function compareCompetitorResultsDetail(detail1: CompetitorResultsDetail | undefined, detail2: CompetitorResultsDetail | undefined): boolean {
  if (!detail1 && !detail2) return true; // Both are undefined or null
  if (!detail1 || !detail2) return false; // One is null or undefined, the other is not
  const detailsFields: (keyof CompetitorResultsDetail)[] = [
    'tl_tm', 'st_tm', 'fn_tm', 'st_dc', 'ch_tm', 'ch_dc', 'fn_dc', 'fn_cp', 'fn_pen', 'fn_tm_pen',
    'tl_tm_pen', 'tl_ch_tm', 'tl_ch_tm_pen', 'LTP', 'team', 'bike', 'league', 'tl_lp'
  ];

  for (const field of detailsFields) {
    if (detail1[field] !== detail2[field]) return false;
  }

  return true;
}

export interface TeamMember {
    id?:string;
    fn?:string; // First name
    ln?:string; // Last name
    tp?:string; // Type
    sx?:string; // Sex
    db?:string; // Day of birth
    mb?:string; // Month of birth
    yb?:string; // Year of birth
    em?:string; // Email
    ts?:string; // Timestamp
    ml?:string; // Miscellaneous
    plc?:string; // Place
    cty?:string; // Country
    cl?:string; // Club
    mp?:string; // Mobile phone
}


